module.exports = __webpack_public_path__ + "img/stones-1.4659415.webp";